import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ShowSection } from "./components/ShowSection";
import { Essays } from "./components/Essays";
import { Quotes } from "./components/Quotes";
import { Footer } from "./components/Footer";
import { EssayDetail } from "./pages/EssayDetail";
import { QuoteDetail } from "./pages/QuoteDetail";
import { LLMView } from "./pages/LLMView";
import { TagPage } from "./pages/TagPage";
import { useSEO } from "./hooks/useSEO";

const ScrollHandler = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, key]);
  return null;
};

const Home = () => {
  useSEO({
    title: "Hunar Syal, Entrepreneur, writer, host of Hangout with Hunar",
    description:
      "Hunar Syal writes essays on mindset, money and careers, and hosts Hangout with Hunar, a long-form conversation show over board games, meals and coffee.",
    image: "/images/bhutan.webp",
    url: typeof window !== "undefined" ? window.location.origin + "/" : undefined,
  });
  return (
    <div data-testid="home-page" style={{ background: "var(--brand-cream)" }}>
      <Navbar />
      <Hero />
      <ShowSection />
      <Essays />
      <Quotes />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollHandler />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/essays/:slug" element={<EssayDetail />} />
        <Route path="/quotes/:slug" element={<QuoteDetail />} />
        <Route path="/tags/:slug" element={<TagPage />} />
        <Route path="/llms" element={<LLMView />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
